import { useNavigate, useParams } from '@tanstack/react-router'
import { Page } from '../../components/layout/AppShell'
import { PageHeader } from '../../components/layout/PageHeader'
import { Badge, Panel, Spinner, ErrorState } from '../../components/ui'
import { fmtDateTime } from '../../lib/format'
import { useTraderScript } from '../trades/useTrades'

export function ScriptDetailPage() {
  const { thesisId, scriptId } = useParams({ from: '/app/theses/$thesisId/scripts/$scriptId' })
  const navigate = useNavigate()
  const { data: script, isLoading, isError } = useTraderScript(scriptId)

  const crumbs = [
    { label: 'Theses', onClick: () => navigate({ to: '/theses' }) },
    { label: `Thesis ${thesisId.slice(0, 8)}`, onClick: () => navigate({ to: '/theses/$thesisId', params: { thesisId } }) },
    { label: `Script ${scriptId.slice(0, 8)}` },
  ]

  if (isLoading) {
    return <Page width="wide" header={<PageHeader crumbs={crumbs} />}><Spinner /></Page>
  }
  if (isError || !script) {
    return <Page width="wide" header={<PageHeader crumbs={crumbs} />}><ErrorState message="Couldn't load this script." /></Page>
  }

  return (
    <Page
      width="wide"
      header={
        <PageHeader
          crumbs={crumbs}
          actions={<Badge tone={script.enabled ? 'green' : 'neutral'}>{script.enabled ? 'enabled' : 'disabled'}</Badge>}
        />
      }
    >
      <Panel title={`Created ${fmtDateTime(script.created_at)}`}>
        <pre className="font-mono text-[11px] whitespace-pre-wrap break-words text-gray-800">
          {script.script ?? ''}
        </pre>
      </Panel>
    </Page>
  )
}
